/* eslint-disable check-file/filename-blocklist */
import { getApolloClient } from '@confluence/graphql';

import {
	CommentPermissionsQuery,
	CommentVersionQuery,
	CommentQuery,
} from '../queries/SingleCommentQuery.graphql.js';

export const isCreateCommentAllowed = async (contentId) => {
	//fetch latest permission status
	const commentsData = await getApolloClient().query({
		query: CommentPermissionsQuery,
		variables: { contentId },
		fetchPolicy: 'network-only',
	});

	const { operations } = commentsData?.data?.content?.nodes[0] ?? [];

	return Boolean(operations.find((op) => op.operation === 'create' && op.targetType === 'comment'));
};

export const fetchCommentVersion = async (commentId) => {
	const commentsData = await getApolloClient().query({
		query: CommentVersionQuery,
		variables: { contentId: commentId },
		fetchPolicy: 'network-only',
	});

	const { version } = commentsData?.data?.content?.nodes[0] ?? null;

	return version;
};

//fetches the Comment the User is Replying to or Editing
export const fetchComment = async (commentId) => {
	const commentsData = await getApolloClient().query({
		query: CommentQuery,
		variables: { contentId: commentId },
		fetchPolicy: 'network-only',
	});

	// comment
	return commentsData?.data?.content?.nodes[0] ?? null;
};

export const createGraphQLError = ({ errorCode }) => ({
	originalError: {
		response: {
			status: errorCode,
		},
	},
});
